import { Stack, Typography, Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import DownloadIcon from '@mui/icons-material/Download'

export default function ReportsToolbar({ onCreate, onExport, canExportReports }) {
    return (
        <Stack direction="row" alignItems="center">
            <Typography variant="h5" fontWeight={700}>
                FMD Workflow
            </Typography>

            <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ ml: 'auto' }}
            >
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={onCreate}
                >
                    New Workflow
                </Button>

                {canExportReports && (
                    <Button
                        variant="outlined"
                        startIcon={<DownloadIcon />}
                        onClick={onExport}
                    >
                        Export Excel
                    </Button>
                )}
            </Stack>
        </Stack>
    )
}